function formatarMoeda2(texto) {
    var valor = parseFloat(texto) || 0;
    var formatado = (valor).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
    return formatado;
}

export default formatarMoeda2;